import classNames from 'classnames'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  selectIsComputingDone,
  selectIsComputingDoneOrFailed,
  selectItineraryError
} from '../../../store/itinerary/itinerary.selectors'
import { addStep } from '../../../store/itinerary/itinerarySlice'
import plus from '../../genericComponents/assets/plus.svg?raw'
import useEventCallback from '../../utils/useEventCallback'
import s from './AddStepButton.less'

const AddStepButton = () => {
  const dispatch = useDispatch()
  const onClick = useEventCallback(() => dispatch(addStep()))
  const isComputingDone = useSelector(selectIsComputingDoneOrFailed)

  return (
    <div
      className={classNames('icon', s.addStepButton, !isComputingDone && 'disabled')}
      onClick={isComputingDone ? onClick : undefined}
      dangerouslySetInnerHTML={{ __html: plus }}
    ></div>
  )
}

export default AddStepButton
